<template>
  <body>
    <ModalAutores :autores="autores" v-show="modalAutores"
      @cerrar="cerrarModal"
      @recargar="recargarAutores"
      @AddAutor="otroAutor"/>
    <aside class="Blk-1">
    </aside>
    <section class="Blk-2">
      <div class="Form">
        <div id="congresoSelect" class="Blk-Campo" v-show="VerSelectCongreso">
          <p id="titReg">Congresos registrados</p>
          <select name="congresos" id="congresosReg" class="campo"
            v-model="congresoSel" @change.prevent="mostrarCongresoVista(congresoSel)">
              <option v-for="congreso in congresos"
                :key="congreso._id"
                :value="congreso">
                {{congreso.nombre}}
              </option>
          </select>
        </div>
        <form @change="cambioFormCong" class="formCongreso">
          <div id="congresoMasOrEdit" class="Blk-Campo" v-show="!VerSelectCongreso">
            <p>Nombre del congreso*</p>
            <input type="text" name="nombre" class="campo" ref="nombreCongreso"
              v-model.trim="congresoVista.nombre"
              spellcheck="false">
          </div>
          <div class="Blk-Campo">
            <p>Lugar</p>
            <input type="text" name="lugar" class="campo" ref=""
              v-model.trim="congresoVista.lugar"
              :disabled = '!habBotAndCamp.habCong'>
          </div>
          <div class="Blk-Campo">
            <p>Organizador</p>
            <input type="text" name="organizador" class="campo" id="" ref=""
              v-model.trim="congresoVista.organizador"
              :disabled = '!habBotAndCamp.habCong'>
          </div>
          <div class="Blk-Campo">
            <p>Fecha</p>
            <input type="text" name="fecha" class="campo" id="fecha" ref=""
              v-model.trim="congresoVista.fecha"
              :disabled = '!habBotAndCamp.habCong'>
            <p>Ciudad</p>
            <input type="text" name="ciudad" class="campo" ref=""
              v-model.trim="congresoVista.ciudad"
              :disabled = '!habBotAndCamp.habCong'>
          </div>
          <div class="Blk-Campo">
            <p>País</p>
            <input type="text" name="pais" class="campo" ref=""
              v-model.trim="congresoVista.pais"
              :disabled = '!habBotAndCamp.habCong'>
          </div>
        </form>
        <div class="Btn-PoneTel">
          <BotonesCRUD
            :desacMas="!habBotAndCamp.actMasP"
            :desacEdit="!habBotAndCamp.actEdiP"
            :desacMenos="!habBotAndCamp.actMenP"
            :desacSave="!habBotAndCamp.actSavP"
            @nuevo="nuevaPonencia"
            @editar="editarPonencia"
            @del="borrarPonencia"
            @save="savePonencia"
          />
        </div>
        <div id="ponenciasSelect" class="Blk-Campo">
          <p>Ponencias</p>
          <select name="ponencia" id="poneReg" class="campo"
            :disabled = 'habBotAndCamp.habPone'
            v-model="ponenciaSel" @change.prevent="mostrarPonenciaVista(ponenciaSel._id)">
              <option v-for="nombrePonencia in nombresPonencias"
                :key="nombrePonencia._id"
                :value="nombrePonencia">
                {{nombrePonencia.nombre}}
              </option>
          </select>
        </div>
        <form @change="cambioFormPone">
          <div id="nombreInput" class="Blk-Campo">
            <p>Nombre completo*</p>
            <textarea name="nombre" class="campo" id="nombreCompleto" ref="" rows="2"
              :disabled = '!habBotAndCamp.habPone'
              v-model.trim="ponenciaVista.nombre"
              spellcheck="false">
            </textarea>
            <div class="minusculas">
              <button @click.prevent="lowCasePlus" :disabled = '!habBotAndCamp.habPone'>
                AB->ab
              </button>
            </div>
          </div>
          <div class="Blk-Campo">
            <p>Autor(es)*</p>
            <div class="campo" @change="cambioAutores" >{{autoresVista}}</div>
            <div class="botonesAut">
              <button class="botAut" @click.prevent="addAutor" :disabled = '!habBotAndCamp.habPone'>+</button>
              <button class="botAut" @click.prevent="delAutor" :disabled = '!habBotAndCamp.habPone'> - </button>
            </div>
          </div>
          <div class="Blk-Campo">
            <p>Resumen*</p>
            <textarea name="resumen" id="resumen" class="campo"
              :disabled = '!habBotAndCamp.habPone'
              v-model.trim="ponenciaVista.resumen"
              spellcheck="false">
            </textarea>
          </div>
          <div class="Blk-Campo">
            <p>Palabras clave</p>
            <input type="text" name="palabrasClave" class="campo"
              :disabled = '!habBotAndCamp.habPone'
              v-model.trim="ponenciaVista.palsClave">
          </div>
          <div class="Blk-Campo">
            <p>Área*</p>
            <select name="area" class="campo"
              :disabled = '!habBotAndCamp.habPone'
              v-model.trim="ponenciaVista.area">
                <option value="1">Antropoespeleología</option>
                <option value="2">Bioespeleología</option>
                <option value="3">Geoespeleología</option>
                <option value="4">Otras</option>
            </select>
            <p>Idioma*</p>
            <input type="text" name="idioma" class="campo"
              :disabled = '!habBotAndCamp.habPone'
              v-model.trim="ponenciaVista.idioma">
          </div>
          <div class="Blk-Campo">
            <div class="check">
              <p>Información reservada</p>
              <input type="checkbox" name="privado"
                :disabled = '!habBotAndCamp.habPone'
                v-model.trim="ponenciaVista.privado">
            </div>
          </div>
        </form>
      </div>
      <div class="Btns">
        <BotonesCRUD
          :desacMas="!habBotAndCamp.actMasC"
          :desacEdit="!habBotAndCamp.actEdiC"
          :desacMenos="!habBotAndCamp.actMenC"
          :desacSave="!habBotAndCamp.actSavC"
          @nuevo="recibeBotonMasCong"
          @editar="recibeBotonEdiCong"
          @del="borrarCongreso"
          @save="saveCongreso"
        />
        <div class="Btn-Pone">
          <BotonesCRUD
            :desacMas="!habBotAndCamp.actMasP"
            :desacEdit="!habBotAndCamp.actEdiP"
            :desacMenos="!habBotAndCamp.actMenP"
            :desacSave="!habBotAndCamp.actSavP"
            @nuevo="nuevaPonencia"
            @editar="editarPonencia"
            @del="borrarPonencia"
            @save="savePonencia"
          />
        </div>
      </div>
    </section>
  </body>
</template>

<script>
import { mapState } from 'vuex' // en Computed está ...mapState(['usuarioEnSesion'])
import BotonesCRUD from '../components/BotonesCRUD.vue'
import ModalAutores from '../components/ModalAutores.vue'
import axios from 'axios'
export default {
  name: 'FormCongPonen',
  components: { BotonesCRUD, ModalAutores },
  created () {
    // Trae los datos de los congresos guardados en la tabla congresos
    this.URLbase = process.env.VUE_APP_ROOT_API
    this.token = this.usuarioEnSesion.tokenUser
    this.getCongresos()
    this.getAutores()
    this.activaModo('INI')
  },
  data () {
    return {
      resSERV: '',
      VerSelectCongreso: true,
      congresos: [],
      congresosBkUp: [],
      congresoVista: {},
      congresoVistaBkUp: {},
      congresoSel: [],
      congresoSelBkUp: [],
      habBotAndCamp: {
        actMasC: false,
        actEdiC: false,
        actMenC: false,
        actSavC: false,
        habCong: false,
        actMasP: false,
        actEdiP: false,
        actMenP: false,
        actSavP: false,
        habPone: false
      },
      modoBkUp: [],
      IsModoSalirMasP: false,
      IsModoSalirEdiP: false,
      nombresPonencias: {},
      ponenciaVista: {},
      ponenciaVistaBkUp: {},
      ponenciaSel: [],
      autores: [],
      autoresPonencia: [],
      autoresPonenciaBkUp: [],
      modalAutores: false,
      URLbase: '',
      token: ''
    }
  },
  methods: {
    async getCongresos () {
      try {
        const url = `${this.URLbase}/congresos/getCongresos`
        const res = await axios.get(url)
        this.congresos = res.data
      } catch (error) {
        alert(error)
      }
    },
    mostrarCongresoVista (congreso) {
      this.congresoVista = congreso
      this.blanquearPonenciaVista()
      this.activaModo('CSPN')
      if (this.congresoSel._id) {
        this.getNombresPonencias(this.congresoSel._id)
      }
    },
    setFocus () {
      // setTimeout(() => { this.$refs.enfoco.focus() }, 300)
      setTimeout(() => { this.$refs.nombreCongreso.focus() }, 300)
    },
    // clic en NUevo o Editar muestra alternativamente el select o el input
    // (para crear o editar) del nombre del congreso y en el componente
    // BotonesCRUD se cambia el nombre del botón: Edi <> Salir Edi
    // VerSelectCongreso es la varible lógica de los v-show
    recibeBotonMasCong () {
      this.VerSelectCongreso = !this.VerSelectCongreso
      this.VerSelectCongreso ? this.botonSalMasCong() : this.botonMasCong()
    },
    botonMasCong () {
      this.congresoVistaBkUp = JSON.parse(JSON.stringify(this.congresoVista))
      this.ponenciaSelBkUp = this.ponenciaSel
      this.ponenciaVistaBkUp = this.ponenciaVista
      this.autoresPonenciaBkUp = this.autoresPonencia
      this.modoBkUp = JSON.parse(JSON.stringify(this.habBotAndCamp))
      this.blanquearCongresoVista()
      this.blanquearPonenciaVista()
      this.activaModo('CMAS')
      this.setFocus()
    },
    botonSalMasCong () {
      this.congresoVista = JSON.parse(JSON.stringify(this.congresoVistaBkUp))
      this.ponenciaSel = this.ponenciaSelBkUp
      this.ponenciaVista = this.ponenciaVistaBkUp
      this.autoresPonencia = this.autoresPonenciaBkUp
      this.autoresVista1()
      this.habBotAndCamp = JSON.parse(JSON.stringify(this.modoBkUp)) // restaura MODO previo
      this.getNombresPonencias(this.congresoSel._id)
    },
    blanquearCongresoVista () {
      this.congresoVista = {
        nombre: '',
        lugar: '',
        organizador: '',
        fecha: '',
        ciudad: '',
        pais: '',
        virtualCong: false
      }
    },
    recibeBotonEdiCong () {
      this.VerSelectCongreso = !this.VerSelectCongreso
      this.VerSelectCongreso ? this.botonSalEdiCong() : this.botonEdiCong()
    },
    botonEdiCong () {
      this.congresoVistaBkUp = JSON.parse(JSON.stringify(this.congresoVista))
      this.congresoSelBkUp = JSON.parse(JSON.stringify(this.congresoSel))
      this.congresosBkUp = JSON.parse(JSON.stringify(this.congresos))
      this.modoBkUp = JSON.parse(JSON.stringify(this.habBotAndCamp))
      this.activaModo('CEDI')
    },
    botonSalEdiCong () {
      this.congresos = JSON.parse(JSON.stringify(this.congresosBkUp))
      this.congresoVista = JSON.parse(JSON.stringify(this.congresoVistaBkUp))
      this.congresoSel = JSON.parse(JSON.stringify(this.congresoSelBkUp))
      this.habBotAndCamp = JSON.parse(JSON.stringify(this.modoBkUp)) // restaura MODO previo
    },
    cambioFormCong () {
      if (this.congresoVista.nombre) {
        this.habBotAndCamp.actMasC
          ? this.activaModo('CMASs')
          : this.activaModo('CEDIs')
      }
      // si se activa esta función es que algo cambió en el formulario de congresos.
      // Para que se active el botón de guardar tiene que darse:
      // En el caso de Nuevo registro- Que el nombre no esté vacío
      // En el caso de edición- Lo mismo
    },
    async borrarCongreso () {
      const response = await this.$root.alertJoa(
        'Estás a punto de borrar el registro de este congreso. Esta acción no puede revertirse ¿Quieres continuar?',
        'W', 'C')
      if (response === 'borrar') {
        const url = `${this.URLbase}/congresos/deleteCongreso`
        const congresoId = { _id: this.congresoVista._id }
        try {
          const result = await axios.post(url, congresoId, {
            headers: {
              authorization: this.token
            }
          })
          console.log('Resultado:', result.status)
          switch (result.status) {
            case 200:
              this.blanquearCongresoVista()
              this.alertJoa('¡Registro borrado con éxito!', 'S')
              this.getCongresos()
              break
            case 500:
              this.alertJoa('Error al borrar registro, intenta otra vez', 'E')
              break
            default:
              this.alertJoa('Algo salió mal, intenta otra vez', 'E')
          }
        } catch (error) {
          console.error(error)
          this.alertJoa('Error al borrar registro, intenta otra vez', 'E')
        }
      }
    },
    async saveCongreso () {
      try {
        const url = `${this.URLbase}/congresos/save`
        const congresoData = this.congresoVista
        axios.post(url, congresoData)
          .then(result => {
            if (result.data === 'success') {
              this.alertJoa('Datos guardados', 'S')
            } else {
              this.alertJoa('Error guardando los datos, intenta otra vez', 'E')
            }
          })
          .catch(error => console.log(error))
        this.blanquearCongresoVista()
        this.blanquearPonenciaVista()
        this.getCongresos()
        this.VerSelectCongreso = true
        if (this.ponenciaSel._id) {
          this.activaModo('CSPS')
        } else {
          this.activaModo('CSPN')
        }
      } catch (error) {
        alert(error)
      }
    },
    async getNombresPonencias (CongId) {
      if (!CongId) { return }
      try {
        const url = `${this.URLbase}/ponencias/getPonenciasList`
        const congresoId = { _id: CongId }
        const res = await axios.post(url, congresoId)
        this.nombresPonencias = res.data
        this.nombresPonencias.length > 0 ? this.activaModo('CSPNp') : this.activaModo('CSPN')
      } catch (error) {
        alert(error)
      }
    },
    mostrarPonenciaVista (ponenciaId) {
      this.getDatosPonencia(ponenciaId)
      this.activaModo('CSPS')
    },
    async getDatosPonencia (ponenciaID) {
      try {
        const url = `${this.URLbase}/ponencias/getPonenciaData`
        const ponenciaId = { _id: ponenciaID }
        const res = await axios.post(url, ponenciaId)
        this.ponenciaVista = res.data
        this.autoresPonencia = res.data.autores
      } catch (error) {
        alert(error)
      }
    },
    blanquearPonenciaVista () {
      this.ponenciaVista = {}
      this.ponenciaSel = []
      this.nombresPonencias = {}
      this.autoresPonencia = []
    },
    nuevaPonencia () {
      this.IsModoSalirMasP = !this.IsModoSalirMasP
      if (this.IsModoSalirMasP) {
        this.ponenciaVistaBkUp = JSON.parse(JSON.stringify(this.ponenciaVista))
        this.autoresPonenciaBkUp = JSON.parse(JSON.stringify(this.autoresPonencia))
        this.ponenciaSelBkUp = this.ponenciaSel
        this.ponenciaVista = {}
        this.ponenciaVista = {
          delCongreso: this.congresoSel._id
        }
        this.activaModo('PMAS')
        this.autoresPonencia = []
        this.ponenciaSel = []
      } else {
        this.ponenciaSel = this.ponenciaSelBkUp
        if (this.ponenciaSel.nombre) {
          this.ponenciaVista = JSON.parse(JSON.stringify(this.ponenciaVistaBkUp))
          this.autoresPonencia = JSON.parse(JSON.stringify(this.autoresPonenciaBkUp))
          this.activaModo('CSPS')
        } else {
          this.activaModo('CSPN')
        }
      }
    },
    editarPonencia () {
      this.IsModoSalirEdiP = !this.IsModoSalirEdiP
      if (this.IsModoSalirEdiP) {
        this.ponenciaVistaBkUp = JSON.parse(JSON.stringify(this.ponenciaVista))
        this.autoresPonenciaBkUp = JSON.parse(JSON.stringify(this.autoresPonencia))
        this.ponenciaSelBkUp = this.ponenciaSel
        this.activaModo('PEDI')
      } else {
        this.ponenciaVista = JSON.parse(JSON.stringify(this.ponenciaVistaBkUp))
        this.autoresPonencia = JSON.parse(JSON.stringify(this.autoresPonenciaBkUp))
        this.ponenciaSel = this.ponenciaSelBkUp
        this.activaModo('CSPS')
      }
    },
    cambioFormPone () {
      if (this.IsModoSalirMasP) {
        if (this.minDataPone) {
          this.activaModo('PMASs')
        } else {
          this.activaModo('PMAS')
        }
      } else if (this.IsModoSalirEdiP) {
        if (this.minDataPone) {
          this.activaModo('PEDIs')
        } else {
          this.activaModo('PEDI')
        }
      }
    },
    async borrarPonencia () {
      const response = await this.$root.alertJoa(
        'Estás a punto de borrar el registro de esta ponencia. Esta acción no puede revertirse ¿Quieres continuar?',
        'W', 'C')
      if (response === 'borrar') {
        const url = `${this.URLbase}/ponencias/deletePonencia`
        const ponenciaId = { _id: this.ponenciaVista._id }
        try {
          const result = await axios.post(url, ponenciaId, {
            headers: {
              authorization: this.token
            }
          })
          console.log('Resultado:', result.status)
          switch (result.status) {
            case 200:
              this.blanquearPonenciaVista()
              this.alertJoa('¡Registro borrado con éxito!', 'S')
              this.getNombresPonencias(this.congresoSel._id)
              break
            case 500:
              this.alertJoa('Error al borrar registro, intenta otra vez', 'E')
              break
            default:
              this.alertJoa('Algo salió mal, intenta otra vez', 'E')
          }
        } catch (error) {
          console.error(error)
          this.alertJoa('Error al borrar registro, intenta otra vez', 'E')
        }
      }
    },
    async savePonencia () {
      this.ponenciaVista.autores = this.autoresPonencia
      this.ponenciaVista.congresoYfecha = `${this.congresoSel.nombre} - ${this.congresoSel.fecha}`
      this.noLineBreaks()
      try {
        const url = `${this.URLbase}/ponencias/save`
        const ponencia = this.ponenciaVista
        axios.post(url, ponencia)
          .then(result => {
            switch (result.data) {
              case 'error':
                this.alertJoa('Error al guardar, intenta otra vez', 'E')
                break
              case 'success':
                this.alertJoa('Datos guardados con éxito!', 'S')
                this.getNombresPonencias(this.congresoSel._id)
                break
            }
          })
      } catch (error) {
        alert(error)
      }
      this.IsModoSalirMasP = false
      this.IsModoSalirEdiP = false
      this.blanquearPonenciaVista()
      this.activaModo('CSPN')
    },
    async getAutores () {
      try {
        const url = `${this.URLbase}/autores/listAutores`
        const res = await fetch(url)
        this.autores = await res.json()
      } catch (error) {
        alert(error)
      }
    },
    // Si la ponencia tiene nombre permite abrir una ventana modal para vincular un autor (o más) a la ponencia.
    // Si el autor no está en la lista, permite escribir y guardar un nuevo autor.
    addAutor () {
      if (this.ponenciaVista.nombre) { this.modalAutores = true }
    },
    recargarAutores () {
      this.getAutores()
    },
    // Elimina el último autor asociado a la ponencia, eliminando el último id guardado en array
    delAutor () {
      this.autoresPonencia.pop()
    },
    // Añade los autores en orden de una ponencia, en el caso de que no estén ya regiatrados
    otroAutor (autorRecibido) {
      if (!this.autoresPonencia.includes(autorRecibido)) { this.autoresPonencia.push(autorRecibido) }
    },
    cerrarModal () {
      this.modalAutores = false
    },
    activaModo (modo) {
      switch (modo) {
        case 'INI':
          this.confModo = [1, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          break
        case 'CSPN':
          this.confModo = [1, 1, 1, 0, 0, 1, 0, 0, 0, 0]
          break
        case 'CSPNp':
          this.confModo = [1, 1, 0, 0, 0, 1, 0, 0, 0, 0]
          break
        case 'CMAS':
          this.confModo = [1, 0, 0, 0, 1, 0, 0, 0, 0, 0]
          break
        case 'CMASs':
          this.confModo = [1, 0, 0, 1, 1, 0, 0, 0, 0, 0]
          break
        case 'CEDI':
          this.confModo = [0, 1, 0, 0, 1, 0, 0, 0, 0, 0]
          break
        case 'CEDIs':
          this.confModo = [0, 1, 0, 1, 1, 0, 0, 0, 0, 0]
          break
        case 'PMAS':
          this.confModo = [0, 0, 0, 0, 0, 1, 0, 0, 0, 1]
          break
        case 'PMASs':
          this.confModo = [0, 0, 0, 0, 0, 1, 0, 0, 1, 1]
          break
        case 'CSPS':
          this.confModo = [1, 1, 0, 0, 0, 1, 1, 1, 0, 0]
          break
        case 'PEDI':
          this.confModo = [0, 0, 0, 0, 0, 0, 1, 0, 0, 1]
          break
        case 'PEDIs':
          this.confModo = [0, 0, 0, 0, 0, 0, 1, 0, 1, 1]
          break
      }
      let i = 0
      for (const key in this.habBotAndCamp) {
        this.confModo[i] === 0
          ? this.habBotAndCamp[key] = false
          : this.habBotAndCamp[key] = true
        i++
      }
    },
    lowCasePlus () {
      this.ponenciaVista.nombre = this.ponenciaVista.nombre.toLowerCase()
      this.ponenciaVista.nombre = this.ponenciaVista.nombre.replaceAll(/\n|\r/g, ' ')
      this.ponenciaVista.nombre = this.ponenciaVista.nombre.replaceAll('  ', ' ')
    },
    noLineBreaks () {
      this.ponenciaVista.resumen = this.ponenciaVista.resumen.replaceAll(/(\r\n|\r|\n)/g, ' ')
      this.ponenciaVista.resumen = this.ponenciaVista.resumen.replaceAll('  ', ' ')
    }
  },

  computed: {
    autoresVista () {
      let resultado = ''
      if (this.autoresPonencia) {
        // const A = this.autoresPonencia.map((e) => this.autores.find((autor) => autor._id === e))
        resultado = this.autoresPonencia.map((ele) => `${ele.nombre} ${ele.apellidos}`).join(', ')
      }
      return resultado
    },
    minDataPone () {
      return (this.ponenciaVista.nombre && this.ponenciaVista.resumen && !!this.autores.length > 0)
    },
    ...mapState(['usuarioEnSesion'])
  },
  watch: {
    autoresVista () {
      if ((this.IsModoSalirEdiP || this.IsModoSalirMasP) && this.autoresPonencia.length > 0) {
        this.cambioFormPone()
      }
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
body {
  width: 100vw;
  height: 82vh;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}
aside.Blk-1 {
  width: 20%;
  background-color: var(--az-cl-tr08);
  border: 0.5px var(--az-cl-tr08);
}
.Btn-PoneTel{
  display: none;
}
section.Blk-2 {
  width: 80%;
  display: grid;
  grid-template-columns: 80% 20%;
  background-color: var(--gr-fo-for);
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 2%;
}
.Form {
  color: darkslategray;
  padding-top: 20px;
}
.formCongreso {
  padding-bottom: 11px;
  border-bottom: solid 1px rgb(78, 78, 78);
}
.Btns {
  display: grid;
  padding-left: 25px;
  padding-top: 20px;
}
.Blk-Campo{
  width: 100%;
  max-width: 100%;
  /* flex:20; */
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 4px;
}
.Blk-Campo p {
  color: black;
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  padding-left: 18px;
  max-width: 90px;
  min-width: 90px;
  margin-bottom: 2px;
  line-height: 98%;
}
.campo{
  height: auto;
  min-height: 26px;
  width: auto;
  min-width: 70px;
  /* margin-left: 10px; */
  padding-left: 8px;
  background-color: var(--gr-fo-cam);
  border: var(--bo-cam);
  border-radius: 3px;
  font-size: 15px;
  color: var(--tx-cam);
  flex: 2;
  text-align: left;
}
.campo:focus{
  outline-color: rgb(250, 189, 132);
}
.check{
  display: flex;
  margin-top: 2%;
}
.check p {
  color: black;
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  padding-left: 18px;
  padding-right: 4px;
  max-width: 150px;
  min-width: 90px;
  margin-bottom: 2px;
  line-height: 98%;
}
.botAut{
  height: auto;
  min-height: 26px;
  width: 26px;
  font-size: 18px;
}
#titReg{
  font-weight: bold;
}
#congresoSelect p {
  font-size: 15px;
  font-weight: bold;
  line-height: 98%;
  margin-bottom:6px;
  /* border: solid 1px orange; */
}
#nombreCongreso {
  font-weight: bold;
  height: 27px;
}
#congresoMasOrEdit p {
  font-size: 14px;
  line-height: 110%;
  margin-bottom:6px
  /* border: solid 1px orange; */
}

#fecha {
  width: 150px; /*no funciona*/
}
#ultimaLineaCongreso{
    padding-bottom: 15px;
}
#ponenciasSelect {
  margin-top: 20px;
}
#ponenciasSelect p{
  font-weight: bold;
  font-size: 15px;
}
#poneReg, #congresosReg {
  font-weight: bold;
  line-height: 95%;
  height: 27px;
  max-width: 96%;
  text-overflow: ellipsis;
}
#nombreInput p{
  line-height: 110%;
}
#nombreCompleto{
  resize: none;
  height: 45px;
}
#resumen{
  height: 100px;
}
.option{
  max-width: 100%;
  text-overflow: ellipsis;
}
@media screen and (max-width: 575px){
  body {
    width: 100vw;
    /* height: auto; */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    overflow-y: auto;
  }
  .Blk-1{
    display: none;
  }
  .Btn-Pone {
    display: none;
  }
  section.Blk-2 {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    align-items: stretch;
    /* background-color: rgba(246, 245, 216, 0.911); */
    overflow-y: auto;
  }
  .Form {
    padding-top: 10px;
  }
  .Blk-Campo {
    flex-direction: column;
    /* align-items:flex-start; */
    align-items:stretch;
  }
  .Blk-Campo p{
    max-width: 190px;
  }
  .campo{
    /* width: 100% no funciona, el ancho se controla con align-items: strech en .Blk-Campo*/
    margin: 0 2% 0 2%;
  }
  .check{
    width: 43%;
    justify-content: space-between;
    margin-top: 6px;
    /* border: solid 1px orange; */
  }
  #nombreSeparata{
    max-width: 96%;
  }
  .Btns {
    padding: 0 2.5% 2% 2.5%;
    /* background-color:  rgba(209, 208, 183, 0.911); */
  }
  .Btn-PoneTel {
    display: flex;
    padding: 0 3% 2% 2.5%;
    /* background-color:  rgba(209, 208, 183, 0.911); */
    position: sticky;
  }
  .minusculas{
    align-self: end;
    margin-right: 2%;
  }
  textarea {
    resize: none;
  }
  .botonesAut{
    align-self: flex-end;
    margin-right: 2.5%;
  }
}
</style>
